import {
  DEFAULT_SORTING,
  DEFAULT_SORTING_EXPERIMENT,
  SORT_OPTIONS_UK,
  SORT_OPTIONS_UK_EXPERIMENT,
  SORT_ORDER_EXPERIMENT_CONTROL,
  SORT_ORDER_EXPERIMENT_VARIANT,
} from '../../Constants/Sort';
import type { FilterParams } from '../../Entities/Search/QueryParams.entity';

type Experiment = {
  variationId: string;
  experimentId: string;
};

export const addDefaultSortingIfMissing = (
  filterParams: FilterParams,
  experiments: Experiment[] = [],
) => {
  const sortOrderExperimentV2 = experiments?.find(
    experiment => experiment.experimentId === 'sort-order-v2-experiment',
  );

  const isVariant = sortOrderExperimentV2?.variationId === '1';

  const defaultSort = isVariant ? SORT_ORDER_EXPERIMENT_VARIANT : SORT_ORDER_EXPERIMENT_CONTROL;

  if (filterParams.sort || !defaultSort) return filterParams;
  return {
    ...filterParams,
    sort: defaultSort,
  };
};

export const getCorrectRelevanceForUk = (experiments: Experiment[] = []) => {
  const sortOrderExperimentV2 = experiments?.find(
    experiment => experiment.experimentId === 'sort-order-v2-experiment',
  );
  const FINAL_SORT_ORDER_UK =
    sortOrderExperimentV2?.variationId === '1' ? SORT_OPTIONS_UK_EXPERIMENT : SORT_OPTIONS_UK;
  const FINAL_DEFAULT_SORTING =
    sortOrderExperimentV2?.variationId === '1' ? DEFAULT_SORTING_EXPERIMENT : DEFAULT_SORTING;
  return {
    FINAL_SORT_ORDER_UK,
    FINAL_DEFAULT_SORTING,
  };
};
